import React from "react";
import { motion } from "framer-motion";

const WHATSAPP_NUMBER = "971508978095";
const WHATSAPP_TEXT =
  "Hi Entrepminds — I'd like to know more about GrowthOS.";

const WhatsAppButton = () => {
  const href = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_TEXT)}`;
  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-btn"
      aria-label="Chat with Entrepminds on WhatsApp"
      title="Chat with us on WhatsApp"
      initial={{ opacity: 0, scale: 0.5, y: 20 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      whileHover={{ scale: 1.06 }}
      transition={{ duration: 0.45, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
      className="fixed bottom-6 right-4 sm:right-6 z-[80] group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 blur-xl group-hover:opacity-70 transition-opacity" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_18px_45px_-12px_rgba(37,211,102,0.55)] border border-white/30">
        <svg viewBox="0 0 32 32" width="26" height="26" fill="currentColor" aria-hidden="true">
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.834 1.23 1.968 2.28 3.334 4.43 4.267.302.13.687.288 1.032.302h.472c.732 0 1.906-.591 2.223-1.348.115-.302.216-.617.216-.933 0-.417-1.535-.634-1.907-.816zm-2.88 7.048h-.028a11.795 11.795 0 0 1-5.938-1.62l-.415-.246-4.31 1.13 1.15-4.2-.273-.43a11.7 11.7 0 0 1-1.79-6.24c.001-6.472 5.267-11.737 11.744-11.737a11.66 11.66 0 0 1 8.297 3.446 11.62 11.62 0 0 1 3.44 8.296c-.004 6.47-5.27 11.6-11.877 11.6zm9.994-21.594A14.062 14.062 0 0 0 16.23 0C8.485 0 2.184 6.298 2.18 14.04A14.02 14.02 0 0 0 4.055 21l-2 7.3 7.463-1.956a14.01 14.01 0 0 0 6.7 1.706h.006c7.743 0 14.046-6.3 14.05-14.043a13.94 13.94 0 0 0-4.05-9.348z" />
        </svg>
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
